export default {
  getAge: function(name, today) {
    return this.getAgeByValue(name, today)
  },

  getAgeByBirth: function(value, today) {
    return this.getAgeByValue(value, today)
  },
  getAgeByValue: function(value, today) {
    if (!value) return false
    var b = value.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
    if (b == null) {
      return null
    } else {
      var month = b[3] * 1
      var day = b[4] * 1
      var nowY = today.getFullYear()
      var age = nowY - b[1]
      if (today.getMonth() + 1 < month) {
        age--
      } else if (today.getMonth() + 1 == month && today.getDate() < day) {
        age--
      }
      if (age < 1) {
        var dayNum = this.getDateDiff(value, nowY + '-' + (today.getMonth() + 1) + '-' + today.getDate())
        // if (dayNum <= 27) {
        //   age--
        // }
        age = dayNum + 'D'
      }
      return age
    }
  },

  /**
   * 取得两个日期的时间差
   */
  getDateDiff: function(date1, date2) {
    var dt1, dt2
    if (date1 instanceof Date) {
      dt1 = date1
    } else {
      dt1 = this.stringToDate(date1)
    }
    if (date2 instanceof Date) {
      dt2 = date2
    } else {
      dt2 = this.stringToDate(date2)
    }
    return (dt2.getTime() - dt1.getTime()) / (1000 * 3600 * 24) + 1
  },

  /**
   * 字符串转日期
   */
  stringToDate: function(string) {
    return new Date(Date.parse(string.replace(/-/g, '/')))
  }
}
